import React from 'react';

import './styles.css';

function DefaultLoader() {
    return <span className="default-loader"></span>
}

export default DefaultLoader;